import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'
import { useMediaQuery } from 'usehooks-ts'


import { useErrorInfoModal, useModalStore } from '@features/modal'
import { useAddressStore } from '@features/shipping-methods'

import TabsSwitcher from '@widgets/modal-delivery/ui/TabsSwitcher'
import { useSlotStore } from '@widgets/slots/model/useSlotStore'


import { Slot, useAvailableSlotsQuery } from '@shared/generated'
// import { useZonesFromAddress } from '@shared/hooks/useZonesFromAddress'
import { cn } from '@shared/lib/cn'
import Button from '@shared/ui/button'

import styles from './styles.module.scss'

export default function SlotsModal () {
  const { t: tc } = useTranslation('common')
  // const { t: tca } = useTranslation('cart')
  const { t: te } = useTranslation('errors')
  const [ activeDate, setActiveDate ] = useState<string>('')
  const { selectedSlot, setSelectedSlot } = useSlotStore()
  // const { freeSlotDeliveryCostFrom, isPickup, deliveryCost } = useZonesFromAddress()
  const { shopId, zoneId, deliveryType } = useAddressStore()
  const isTablet = useMediaQuery('(max-width: 991px)')
  const { closeModal } = useModalStore()
  const [ selectedLocalSlot, setSelectedLocalSlot ] = useState<Slot | null>(null)
  const { openErrorInfoModal } = useErrorInfoModal()

  const variables = useMemo(() => {
    if (deliveryType === 'slot') return { zoneId }
    return { shopId }
  }, [ deliveryType, zoneId, shopId ])

  const shouldFetch = deliveryType === 'slot' ? !!zoneId : !!shopId

  const { data: slotsData } = useAvailableSlotsQuery({
    variables,
    skip: !shouldFetch,
    onError: () => {
      openErrorInfoModal({ description: te('get_slots_data') })
    },
  })

  const SLOTS_GROUP = useMemo(() => {
    if (!slotsData) return
    type Slot = NonNullable<typeof slotsData.availableSlots>[number];
    const group: Record<string, Slot[]> = {}
    slotsData.availableSlots?.forEach((slot) => {
      const key = slot?.slotDate as string
      if (!slot) return
      if (group[key]) group[key].push(slot)
      else group[key] = [ slot ]
    })
    return group
  }, [ slotsData ])

  useEffect(() => {
    if (!SLOTS_GROUP) return

    const firstDate = Object.keys(SLOTS_GROUP)[0]

    if (selectedSlot) {
      setActiveDate(selectedSlot.slotDate as string)
      setSelectedLocalSlot(selectedSlot)
    }
    else {
      setActiveDate((prev) => prev || firstDate)

      const firstSlot = SLOTS_GROUP[firstDate]?.[0]
      if (firstSlot) {
        setSelectedLocalSlot(firstSlot)
        setSelectedSlot(firstSlot)
      }
    }
  }, [ SLOTS_GROUP, selectedSlot, setSelectedSlot ])
  const dateTabs = useMemo(() => {
    if (!SLOTS_GROUP) return []
    return Object.keys(SLOTS_GROUP).map((date) => ({
      label: date,
      value: date,
    }))
  }, [ SLOTS_GROUP ])

  useEffect(() => {
    if (SLOTS_GROUP) {
      setActiveDate(Object.keys(SLOTS_GROUP)[0])
    }
  }, [ SLOTS_GROUP ])

  return (
    <div className={styles.root}>
      <div className={styles.root__group}>
        {/* {!isPickup() && (
          <div className={styles.cost}>
            <ReactSVG
              className={styles['cost__icon']}
              src="/icons/gift.svg"
              wrapper="span"
            />
            <div className={styles['cost__wrapper']}>
              <p className={styles['cost__title']}>{tca('delivery.free')}</p>
              {deliveryCost ? (
                <p className={styles['cost__price']}>
                  {tca('delivery.amount_to', {
                    amount: formatPrice(freeSlotDeliveryCostFrom),
                  })}
                </p>
              ) : null}
            </div>
          </div>
        )} */}

        <h3 className={styles['root__group-title']}>{tc('slots.date')}</h3>
        <TabsSwitcher
          tabs={dateTabs}
          active={activeDate}
          cols={Object.keys(SLOTS_GROUP || {}).length}
          onChange={setActiveDate}
        />
      </div>

      <div className={styles.root__group}>
        <h3 className={styles['root__group-title']}>{tc('slots.time')}</h3>

        <div className={styles.root__list}>
          {SLOTS_GROUP?.[activeDate]?.map((slot) => (
            <div
              className={cn(styles.root__slot, {
                [styles.active]: selectedLocalSlot?.id === slot?.id,
              })}
              key={slot?.id}
              onClick={() => setSelectedLocalSlot(slot)}
            >
              <div className={styles['root__slot-name']}>
                {slot?.slotDate} {tc('from')} {slot?.slotTime}
              </div>
              <div className={styles['root__slot-check']}>
                <ReactSVG src="/icons/circle-check-filled.svg" />
              </div>
            </div>
          ))}
        </div>

        <Button
          size={isTablet ? 'medium' : 'large'}
          onClick={() => {
            if (selectedLocalSlot) {
              setSelectedSlot(selectedLocalSlot)
              closeModal('slots')
            }
          }}
        >
          {tc('choose')}
        </Button>
      </div>
    </div>
  )
}
